
<div class=" gray-background content px-3 pb-3">
    <campaign-detail-create *ngIf="currentUser.permissions.isClient || currentUser.permissions.isEmployee || currentUser.permissions.isAdmin" [showPackage]="showPackage" (campaign)="campaginDetailAdded($event)" [baseCampaign]="baseCampaign" (onStepTwo)="onNextStepTwo($event)"></campaign-detail-create>
</div>